.wrapper {
  background-color: var(--mantine-color-gray-0);
  position: relative;
}

.dropzone {
  border: 1px dashed var(--mantine-color-gray-2);
}

.icon {
  color: light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-3));
}

.control {
  position: absolute;
  width: 250px;
  left: calc(50% - 125px);
  bottom: -20px;
}

.wrapper[data-required="true"] > * {
  background-color: lighten(var(--mantine-color-error), 90%);
  border-color: var(--mantine-color-error);
  border: 1px dashed var(--mantine-color-error);
  color: var(--mantine-color-error);
  &:hover {
    cursor: pointer;
    background-color: lighten(var(--mantine-color-error), 80%);
  }
}

.wrapper[data-required="true"] > * > * > * > * > p {
  color: var(--mantine-color-error) !important;
}

.wrapper[data-required="true"] > * > * > * > p > span {
  color: var(--mantine-color-error) !important;
}

.wrapper[data-required="true"] .mantine-Dropzone-root {
  background-color: lighten(var(--mantine-color-error), 80%);
  border: 1px dashed var(--mantine-color-error);
}

.wrapper[data-required="true"] .mantine-Dropzone-inner p {
  color: var(--mantine-color-error);
}

.wrapper[data-required="true"] .mantine-Dropzone-inner span {
  color: var(--mantine-color-error);
}
